import { render, staticRenderFns } from "./editService.vue?vue&type=template&id=63e3b2a9&scoped=true&"
import script from "./editService.vue?vue&type=script&lang=js&"
export * from "./editService.vue?vue&type=script&lang=js&"
import style0 from "./editService.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./editService.vue?vue&type=style&index=1&id=63e3b2a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e3b2a9",
  null
  
)

component.options.__file = "editService.vue"
export default component.exports